import { IPageTest } from '@maxpreps/shared/functions/server/IPageTest';
import { Page } from './../utils/pages';
import { schedulePageTest } from './../utils/schedulePageTest';

const {
  endsWith
} = require('@maxpreps/shared/functions/server/pageMappingUtils');

const WEBFORMS_MANAGED_PAGES = [
  '/calendar',
  '/awards',
  '/preview',
  '/staff/all-time',
  '/schedule/all-time'
];

const rewrittenPages: IPageTest[] = [
  /*{
    test: url => true,
    react: '/roster/quick-edit'
  },*/
  {
    test: url => endsWith(Page.Schedule_Edit, url),
    react: '/schedule/contest-form'
  },
  schedulePageTest,
  {
    test: url => endsWith(Page.Rankings, url),
    react: '/rankings'
  },
  {
    test: url => endsWith(Page.Standings, url),
    react: '/standings'
  },
  {
    test: url => endsWith(Page.PhotoGalleries, url),
    react: '/media/photo-galleries'
  },
  // retired
  // {
  //   test: url => endsWith(Page.Parents, url),
  //   react: '/parents'
  // },
  {
    test: url => endsWith(Page.PreviousSeasons, url),
    react: '/previous-seasons'
  },
  {
    test: url => endsWith(Page.Roster_AllTime, url),
    react: '/all-time-roster'
  },
  {
    test: url => endsWith(Page.Roster_Edit, url),
    react: '/roster/athlete-form'
  },
  {
    test: url => endsWith(Page.Roster_BulkEdit, url),
    react: '/roster/athlete-bulk-form'
  },
  {
    test: url => endsWith(Page.Roster_Print, url),
    react: '/roster/roster-print'
  },
  {
    test: url => endsWith(Page.Roster, url),
    react: '/roster'
  },
  {
    test: url => endsWith(Page.Stats, url),
    react: '/stats'
  },
  {
    test: url => endsWith(Page.Staff, url),
    react: '/staff'
  },
  {
    test: url => endsWith(Page.Articles, url),
    react: '/media/articles'
  },
  {
    test: url => endsWith(Page.Videos, url),
    react: '/media/videos'
  },
  {
    test: url => endsWith(Page.AdminDashboard, url),
    react: '/admin-dashboard'
  },
  // TODO: Fix this - team home is picking up to much
  // this needs work...
  {
    test: url =>
      //console.log('Url', url, WEBFORMS_MANAGED_PAGES);

      endsWith('/', url) &&
      (!url?.pathname ||
        WEBFORMS_MANAGED_PAGES.every(p => url.pathname.indexOf(p) === -1)),
    react: '/'
  }
];

// stuff the home page shouldn't manage

module.exports = rewrittenPages;

export default rewrittenPages;
